export function getAttributeByPath(obj: any, path: Array<string>) {
  return path.reduce((acc, key) => acc && acc[key], obj);
}
